import { render, staticRenderFns } from "./SearchResultOrg.vue?vue&type=template&id=1c7d8db2"
import script from "./SearchResultOrg.ts?vue&type=script&lang=ts&external"
export * from "./SearchResultOrg.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports